import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ImageWithDescription from "../../components/ImageAndText/ImageWithDescription";
import image from "../../imgs/image2.png";
import Step2Form from "./Forms/Step2Form";
import CustomAccordion from "../../components/Accordion/Accordion";
import { useLocation } from "react-router-dom";

const Solution2 = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accordionBusinessItems = [
    {
      title:
        "En quoi la blockchain peut-elle réduire les coûts liés à la conformité CSRD ?",
      content:
        "Grâce à l’automatisation des processus de reporting ESG via la blockchain, les entreprises peuvent réduire le temps et les ressources consacrées à la collecte et à la vérification des données. Cela diminue les coûts de conformité tout en améliorant la précision des rapports.",
    },
    {
      title:
        "Comment la blockchain peut-elle aider les entreprises à se conformer aux exigences de la CSRD ?",
      content:
        "La blockchain permet aux entreprises de garantir la transparence et l'authenticité des données rapportées en matière de durabilité. Les exigences de la CSRD en termes de reporting régulier et de traçabilité peuvent être facilement satisfaites, car les informations ESG immuables stockées sur la blockchain sont vérifiables par les régulateurs et les parties prenantes.",
    },
    {
      title:
        "Comment l’utilisation de la blockchain pour le reporting ESG permet-elle d’améliorer la réactivité face aux régulations changeantes ?",
      content:
        "Grâce à la blockchain, les entreprises peuvent adapter leurs rapports ESG en temps réel, intégrant automatiquement de nouvelles exigences réglementaires. Cela réduit les coûts de mise en conformité tout en assurant un suivi continu et auditable",
    },
    {
      title:
        "Comment le reporting ESG peut-il contribuer à la fidélisation des clients ?",
      content:
        "En communiquant des informations transparentes et vérifiées sur les performances environnementales et sociales, le reporting ESG aide les entreprises à établir une relation de confiance avec leurs clients. Les consommateurs, de plus en plus attentifs à l'impact environnemental et social des produits qu'ils achètent, sont plus susceptibles de rester fidèles à des marques qui démontrent un véritable engagement envers la durabilité.",
    },
  ];

  const accordionTechniquesItems = [
    {
      title:
        "Quels types d'outputs peut-on obtenir d'une blockchain et sous quels formats sont-ils disponibles ?",
      content:
        "Les outputs d'une blockchain incluent des données transactionnelles détaillées telles que les horodatages, les adresses des participants, et les métadonnées associées. Ces informations peuvent être exportées sous différents formats, tels que JSON ou CSV, pour faciliter leur traitement et analyse dans des systèmes externes. Les logs d'événements liés aux smart contracts, comme les changements d'état ou l'exécution de conditions spécifiques, peuvent également être récupérés. En fonction du type de blockchain et de l'interface d'accès utilisée (API, explorateur), les données peuvent être présentées sous forme brute ou agrégée pour des rapports analytiques et visualisations.",
    },
    {
      title: "Comment la blockchain peut-elle gérer le volume croissant de données ESG ?",
      content: "La gestion de gros volumes de données ESG peut être facilitée par des solutions de scalabilité comme le sharding ou les sidechains, qui divisent les données en fragments plus petits ou en chaînes parallèles, améliorant ainsi la capacité de traitement sans compromettre la sécurité.",
    },
    {
      title: "Quels sont les défis associés à l’implémentation de la blockchain ?",
      content: "La scalabilité est un problème majeur, car les blockchains, en particulier les modèles basés sur la preuve de travail (PoW), peuvent devenir lentes et coûteuses à mesure que le volume de transactions augmente. De plus, la complexité technique de l'intégration de la blockchain dans des systèmes existants peut freiner son adoption, nécessitant des compétences en cryptographie, en gestion de réseaux décentralisés, et en développement de smart contracts. Enfin, l'absence de standardisation et d'interopérabilité entre les différentes plateformes blockchain crée des silos technologiques, rendant difficile l'échange de données entre systèmes distincts.",
    },
    {
      title: "Comment la blockchain peut-elle intégrer des capteurs IoT pour automatiser la collecte des données ?",
      content: "En couplant des capteurs IoT (Internet des Objets) avec la blockchain, les données ESG telles que les émissions de CO2 ou la consommation d’énergie peuvent être automatiquement collectées et enregistrées en temps réel. Les smart contracts peuvent ensuite analyser ces données et ajuster les processus ou générer des rapports sans intervention humaine.",
    },
  ];

  return (
    <div className="esg-wrapper">
      <Header text="Reporting ESG" />
      <ImageWithDescription
        imageSrc={image}
        imageAlt="Image Information"
        description={[
          "Dans le cadre du reporting ESG, la blockchain assure la transparence, la traçabilité et l'immutabilité des données à chaque étape de la chaîne d'approvisionnement. En intégrant les données ESG de manière automatisée, les entreprises réduisent le temps requis pour la préparation des rapports tout en minimisant les erreurs humaines. Cette intégration facilite également l'agrégation des données provenant de différents acteurs, permettant de générer rapidement un rapport global conforme aux exigences de la directive Corporate Sustainability Due Diligence (CSDDD).",
          "Pour cette démonstration, le processus a été simplifié afin de se concentrer sur une seule étape. Vous allez pouvoir consulter et télécharger les données ESG encodées de la chaîne d'approvisionnement.",
        ]}
      />
      <div className="container">
        <div className="steps-info">
          <h3 className="step-title">Etape 2: Vérification des données ESG</h3>
        </div>

        <Step2Form />

        <div className="accordians-wrapper">
          <div className="accordians-bussiness-main">
            <h3>Questions Business</h3>
            <CustomAccordion items={accordionBusinessItems} />
          </div>

          <div className="accordians-techniques-main">
            <h3>Questions Techniques</h3>
            <CustomAccordion items={accordionTechniquesItems} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Solution2;
